import type {
  RetailerUpdateRequestType,
  RetailerUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useBuyerUpdate = (buyerId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: RetailerUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `retailers/${buyerId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as RetailerUpdateResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Retailers, buyerId],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Retailers],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Businesses],
      });
    },
  });
};
